import { render, staticRenderFns } from "./SendSmsActionDescription.vue?vue&type=template&id=167b124e&"
import script from "./SendSmsActionDescription.vue?vue&type=script&lang=js&"
export * from "./SendSmsActionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports